import { CSSProperties, FC } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

export interface SwatchLabelProps {
  /** Outlines the swatch. Map layers take their border from the icon; adequacy outcomes supply their own. */
  borderColor?: string;
  color: string;
  iconName: string;
  label: string;
}

/**
 * QesIcon's own `color` prop sets the *stroke*, which leaves these icons as outlines, so the swatch is
 * styled through pathStyle instead.
 *
 * The pin's path draws the teardrop and its inner circle as two subpaths of one path, so evenodd turns the
 * circle into a hole rather than filling it, and a hairline stroke outlines both. That is what the map draws:
 * NetworkCoverageMap passes the Mapbox pin icon_primary_border and icon_center_border of black over a white
 * centre. Members are a plain filled dot, so they take neither.
 */
export const swatchPathStyle = (color: string, iconName: string, borderColor?: string): CSSProperties => {
  if (iconName === QesIcons.ProviderMapPin) return { fill: color, fillRule: "evenodd", stroke: "black", strokeWidth: 1 };

  return borderColor
    ? { fill: color, stroke: borderColor, strokeWidth: 1 }
    : { fill: color, stroke: "none" };
};

export const SwatchLabel: FC<SwatchLabelProps> = ({ borderColor, color, iconName, label }: SwatchLabelProps) => (
  <span className="multi-map-export__swatch-label">
    <QesIcon
      className="multi-map-export__swatch"
      height="1rem"
      iconName={iconName}
      isDecorative={true}
      pathStyle={swatchPathStyle(color, iconName, borderColor)}
      width="1rem"
    />
    {label}
  </span>
);

export default SwatchLabel;
